// extracted by mini-css-extract-plugin
export default {"services":"subscriptions_services__j9Av7"};